var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroups({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 6.75H4.375C5.625 6.75 6.25 6.125 6.25 4.875V3.625C6.25 2.375 5.625 1.75 4.375 1.75H3.125C1.875 1.75 1.25 2.375 1.25 3.625V4.875C1.25 6.125 1.875 6.75 3.125 6.75Z",
    stroke: "#070708",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 6.75H11.875C13.125 6.75 13.75 6.125 13.75 4.875V3.625C13.75 2.375 13.125 1.75 11.875 1.75H10.625C9.375 1.75 8.75 2.375 8.75 3.625V4.875C8.75 6.125 9.375 6.75 10.625 6.75Z",
    stroke: "#070708",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.625 14.25H11.875C13.125 14.25 13.75 13.625 13.75 12.375V11.125C13.75 9.875 13.125 9.25 11.875 9.25H10.625C9.375 9.25 8.75 9.875 8.75 11.125V12.375C8.75 13.625 9.375 14.25 10.625 14.25Z",
    stroke: "#070708",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.125 14.25H4.375C5.625 14.25 6.25 13.625 6.25 12.375V11.125C6.25 9.875 5.625 9.25 4.375 9.25H3.125C1.875 9.25 1.25 9.875 1.25 11.125V12.375C1.25 13.625 1.875 14.25 3.125 14.25Z",
    stroke: "#070708",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroups);
export default __webpack_public_path__ + "static/media/groups.7f041ac4961f89911e62051f30017fdd.svg";
export { ForwardRef as ReactComponent };